import React, { useEffect } from "react";
import { Navbar, Footer } from "./componetns";
import { Home, About, SkillsSlider, Portfolio, Contact } from "./pages";
import { Provider } from "react-redux";
import { store } from "./redux/store";
const App = () => {
  useEffect(() => {
    const getData = JSON.parse(localStorage.getItem("isDark"));
    if (getData === null) {
      localStorage.setItem("isDark", JSON.stringify(true));
    }
  });
  return (
    <Provider store={store}>
      <Navbar />
      <Home />
      <About />
      <SkillsSlider />
      <Portfolio />
      <Contact />
      <Footer />
    </Provider>
  );
};

export default App;
